import { gql } from '@apollo/client';

export const CREATE_VEHICLE = gql`
  mutation CreateTmsVehicle($input: TmsVehicleInput!) {
    createTmsVehicle(input: $input)
  }
`;

export const UPDATE_VEHICLE = gql`
  mutation UpdateTmsVehicle($input: TmsVehicleInput!) {
    updateTmsVehicle(input: $input)
  }
`;
